<div class="fieldset">
  <h1><span>{{heading}}</span></h1> {{text}}
</div>
